import Comment from '../templates/Comment'
import {useState} from 'react'
import RespondForm from './RespondForm'
import {answerData} from '../../helpers/data/answer-data'
import RespondPublication from './RespondPublication'
import uniqid from 'uniqid'

const CommentPublication = ({data, publication}) => {
  const [showResponds, setShowResponds] = useState(false)
  return (
    <>
      <Comment commentButtonClick={() => setShowResponds(!showResponds)} data={data} />
      {showResponds && (
        <>
          {/* Cambiar esto por la data de las respuestas */}
          {answerData.data.map(respond => (
            <RespondPublication key={uniqid()} data={respond} />
          ))}
          <RespondForm isAnswer text={`Responder a ${publication.author.firstname}`} />
        </>
      )}
    </>
  )
}

export default CommentPublication
